// extracted by mini-css-extract-plugin
export default {"informationCourse":"OtherInformation_informationCourse__Ruohf","infoRow":"OtherInformation_infoRow__EhPMH","headingText":"OtherInformation_headingText__wJcMt"};